import {cancelActiveRequests} from '~/composables/useFetchWithToken'
import {useRouter} from 'vue-router'

export default defineNuxtPlugin(() => {
    const router = useRouter()

    router.beforeEach((to, from, next) => {
        if (to.fullPath.split('?')[0] !== from.fullPath.split('?')[0]) {
            cancelActiveRequests()
        }
        next()
    })
})